import { ValidatorFn } from '@angular/forms';

//Expansion Coefficient rule (SBTMTAPWP-5152), mirroring TL.Portal.API.DTO.CoefficientExpansion: optional, a
//blank saves the default, and only a value that differs from the loaded one has to be in range, so a tank or
//product already holding an out-of-range value can still save its other fields.
export const COEFF_EXP_DEFAULT = 0.0005;
export const COEFF_EXP_MIN = 0.0001;
export const COEFF_EXP_MAX = 0.002;
export const COEFF_EXP_RANGE_MESSAGE = `Enter a value between ${COEFF_EXP_MIN} and ${COEFF_EXP_MAX}.`;

const isBlank = (value: unknown) => value === null || value === undefined || value === '';

export function coeffExpValidator(loadedValue: () => number | null | undefined): ValidatorFn {
  return control => {
    if (isBlank(control.value)) return null;
    const value = Number(control.value);
    const loaded = loadedValue();
    if (!isBlank(loaded) && value === Number(loaded)) return null;
    return value >= COEFF_EXP_MIN && value <= COEFF_EXP_MAX ? null : { coeffExpRange: true };
  };
}

export function coeffExpOrDefault(value: unknown): unknown {
  return isBlank(value) ? COEFF_EXP_DEFAULT : value;
}
